"use client";

import React from "react";
import { IPageWrapperProps } from "@/app/shared/interfaces";
import { generateStringId, getFormattedDate } from "@/app/shared/utils/utils";
import { getPostBySlug } from "@/app/shared/utils/getPostBySlug";
import { IoCalendar } from "react-icons/io5";
import Image from "next/image";
import Breadcrumbs from "@/app/shared/components/Breadcrumbs/Breadcrumbs";
import SocialMedia from "@/app/components/SocialMedia/SocialMedia";
import BackwardsArrowLink from "../BackwardsArrowLink/BackwardsArrowLink";

interface IComponentProps extends IPageWrapperProps {
  slug: string;
}

const BlogPageWrapper: React.FC<IComponentProps> = ({ slug, children }) => {
  const post = getPostBySlug(slug);

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 lg:py-24">
      <Breadcrumbs />
      <div className="inline-flex items-center gap-5 flex-wrap">
        <BackwardsArrowLink href="/blog" text="blog" />
        {post.categories && (
          <ul className="flex flex-wrap" aria-label="Technologies Used">
            {post.categories.map((category) => (
              <li className="mr-1.5" key={generateStringId()}>
                <div className="flex items-center rounded-full bg-blue-400/10 px-3 py-1 text-xs font-medium leading-5 text-blue-300">
                  {category}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="mt-6">
        <h1 className="leading-light font-bold text-2xl lg:text-5xl tracking-widest text-slate-200">
          {post.title}
        </h1>
        <div className="mt-6 flex items-center justify-between text-sm border-b border-t border-slate-600 py-3">
          <div className="inline-flex items-center">
            <Image
              alt={post.author.name}
              src={post.author.imageSrc}
              width={28}
              height={28}
              priority
              decoding="async"
              className="object-cover rounded-full inline-block mr-2"
            />
            {post.author.name}
          </div>
          <div>
            <IoCalendar
              className="mr-2 inline-block"
              style={{ marginBottom: "3.5px" }}
            />
            {getFormattedDate(post.date)}
          </div>
        </div>

        <div className="mt-8">
          <Image
            alt={post.title}
            src={post.bannerSrc}
            loading="eager"
            width={1920}
            height={1080}
            decoding="async"
            className="w-full h-auto object-cover rounded-md"
            style={{ color: "transparent" }}
          />
        </div>
        {children}
        <div className="mt-20">
          <SocialMedia text="Follow Me" />
        </div>
      </div>
    </div>
  );
};

export default BlogPageWrapper;
